import ReportResults from '@/components/ReportResults'
import Container from '@/components/Container'

export default {
  props: {
    name: { required: true, type: String }
  },
  components: {
    ReportResults,
    Container
  },
  methods: {
    loadReportDetails(reportName) {
      return this.graphql(
        /* GraphQL */ `
          query lookupOptions_ReportDetailsLookup($reportName: String!) {
            allMetricsDashReports(condition: { reportName: $reportName }) {
              nodes {
                reportDescription
                reportDetails
              }
            }
          }
        `,
        { reportName }
      )
    },
    buildReportQuery(reportDetails) {
      let params = reportDetails.params || []
      if (reportDetails.orderType) {
        params.push({
          field: 'orderBy',
          passArray: true,
          type: this.reportDetails.orderType,
          required: true
        })
      }
      return this.buildGraphqlQuery(
        reportDetails.lookup,
        [
          {
            nodes: true,
            fields: (reportDetails && reportDetails.reportFields
              ? reportDetails.reportFields
              : []
            )
              .map(
                field =>
                  (field.field || field.key || field.name || field).split(
                    '.'
                  )[0]
              )
              .filter((value, index, self) => self.indexOf(value) === index)
          }
        ],
        {
          searchName: 'reportQuery',
          first: reportDetails.numRecords,
          filters: this.buildFiltersObject(reportDetails.filters),
          conditions: reportDetails.conditions,
          params: params.length ? params : null
        }
      )[0]
    },
    getReportFields(reportDetails) {
      if (!reportDetails.reportFields) {
        return []
      }
      return reportDetails.reportFields
        .filter(field => this.showHideVIf(field))
        .map(field =>
          typeof field == 'string'
            ? { key: field, field }
            : {
                ...field,
                key: field.key || field.field || field.name
              }
        )
    },
    getReportRecords(allReportData, reportFields) {
      let records = []
      allReportData.forEach(record => {
        let recordData = {}
        if (record.reportInfo) {
          recordData.reportInfo = record.reportInfo
        }
        if (record.actionPerformed) {
          recordData.actionPerformed = record.actionPerformed
        }
        reportFields.forEach(field => {
          if (/^keys:\d+$/.test(field.field)) {
            recordData[field.key || field.name || field.field] =
              record.keys[parseInt(field.field.split(':')[1])]
          } else if (field.field && field.field.split('.').length > 1) {
            recordData[field.key || field.name || field.field] =
              record[field.field.split('.')[0]][field.field.split('.')[1]]
          } else {
            recordData[field.key || field.name || field.field || field] =
              record[field.key || field.name || field.field || field]
          }
        })
        records.push(recordData)
      })
      return records
    },
    buildFiltersObject(filtersArray) {
      let filtersObject = {}
      if (filtersArray) {
        filtersArray.forEach(filter => {
          if (filter.type == 'daterange') {
            filtersObject[filter.field] = {
              type: 'Date',
              required: filter.required,
              greaterThanOrEqualTo: { required: filter.startRequired },
              lessThanOrEqualTo: { required: filter.endRequired }
            }
          } else if (filter.join) {
            filtersObject[filter.join] = {
              fields: this.buildFiltersObject(filter.fields)
            }
          } else {
            filtersObject[filter.field] = {}
            Object.keys(filter).forEach(filterKey => {
              if (filterKey != 'field') {
                filtersObject[filter.field][filterKey] = filter[filterKey]
              }
            })
          }
        })
      }
      return JSON.stringify(filtersObject) == '{}' ? null : filtersObject
    }
  }
}
